<template>
  <div class="ui-datepicker">
    <ui-input
      ref="input"
      v-model="localValue"
      :disabled="disabled"
      clearable
      :label="label"
      placeholder="дд.мм.гггг"
      autocomplete="off"
      mask="date"
      :validate="validate"
      @blur="onBlur"
    />
  </div>
</template>

<script>

export default {
  name: 'ui-datepicker',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Дата',
    },
    outputFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    validate: {
      type: [String, Array],
      default: () => ['date', 'required'],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    localValue: '',
  }),

  watch: { // покрывает кейс, когда при удалении ребенка из формы не обновляется localValue
    modelValue(val) {
      const [d, m, y] = this.parseDate(val);
      this.localValue = `${d}.${m}.${y}`;
    },
  },

  created() {
    const [d, m, y] = this.parseDate(this.modelValue);
    this.localValue = `${d}.${m}.${y}`;
  },
  methods: {
    parseDate(v = this.localValue) { // на выход [d, m, y]
      if (v.split('.').length === 3) { // 15.05.1995
        return v.split('.');
      }

      if (v.split('-').length === 3) { // "1995-05-15"
        const [y, m, d] = v.split('-');
        return [d, m, y];
      }

      // добавить другие встречающиеся форматы
      return [];
    },
    outputDate([d, m, y]) {
      return this.outputFormat
        .replace('YYYY', y)
        .replace('MM', m)
        .replace('DD', d);
    },
    onBlur() {
      if (!this.$refs.input.valid) return;
      this.$emit('update:modelValue', this.outputDate(this.parseDate()));
    },
    checkValidOutside() {
      return this.$refs?.input?.checkValidOutside();
    },
  },
};
</script>
